import { CloseOutlined } from "@mui/icons-material";
import EventIcon from "@mui/icons-material/Event";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import { Accordion, AccordionDetails, AccordionSummary, Button } from "@mui/material";
import { DatePicker } from "@mui/x-date-pickers";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { isValid, parseISO } from "date-fns";
import { enUS } from "date-fns/locale";
import { memo, useState } from "react";

import ActiveFilterIndicator from "./ActiveFilterIndicator";

const DEFAULT_DATE_PICKER_SLOT_PROPS = { textField: { variant: "outlined" } };

const DateRange = ({
  dateFrom,
  datePickerSlotProps = DEFAULT_DATE_PICKER_SLOT_PROPS,
  dateTo,
  fieldName,
  isActive,
  title,
  updateFilter,
}) => {
  const [open, setOpen] = useState(false);

  const handleOnDateChange = (newValue, filterExtension = "") => {
    if (!!newValue && !isValid(newValue)) {
      return;
    }

    const filterKey = fieldName + filterExtension;
    const filterValue = !newValue ? null : new Date(newValue).toISOString().slice(0, 10);

    updateFilter(filterKey, filterValue);
  };

  return (
    <Accordion expanded={open} onChange={() => setOpen(!open)} className="w-full">
      <AccordionSummary
        className="text-sm"
        expandIcon={<ExpandMoreIcon />}
        aria-controls="panel1a-content"
        id="panel1a-header"
        sx={{ "& .MuiAccordionSummary-content": { marginTop: 0 } }}
      >
        <div className="flex flex-row items-center">
          <EventIcon style={{ color: "#757575" }} />
          <span className="ml-2">{title} Range&nbsp;</span>
          {isActive && (
            <span className="ml-2">
              <ActiveFilterIndicator />
            </span>
          )}
        </div>
      </AccordionSummary>
      <AccordionDetails>
        <LocalizationProvider dateAdapter={AdapterDateFns} adapterLocale={enUS}>
          <div className="flex items-center mb-2">
            <DatePicker
              format="MM/dd/yyyy"
              className="w-full my-1 ml-1 text-center"
              label={`${title} From`}
              value={dateFrom ? parseISO(dateFrom) : null}
              onChange={(newValue) => handleOnDateChange(newValue, "__gte")}
              slotProps={datePickerSlotProps}
            />
            {dateFrom && (
              <Button
                type="text"
                onClick={() => handleOnDateChange(null, "__gte")}
                className="p-0 text-sm text-red-600 h-fit w-fit hover:bg-transparent hover:text-red-400"
              >
                <CloseOutlined />
              </Button>
            )}
          </div>

          <div className="flex items-center">
            <DatePicker
              format="MM/dd/yyyy"
              className="w-full my-1 ml-1 text-center"
              label={`${title} To`}
              value={dateTo ? parseISO(dateTo) : null}
              minDate={parseISO(dateFrom) || undefined}
              onChange={(newValue) => handleOnDateChange(newValue, "__lte")}
              slotProps={datePickerSlotProps}
            />
            {dateTo && (
              <Button
                type="text"
                onClick={() => handleOnDateChange(null, "__lte")}
                className="p-0 text-sm text-red-600 h-fit w-fit hover:bg-transparent hover:text-red-400"
              >
                <CloseOutlined />
              </Button>
            )}
          </div>
        </LocalizationProvider>
      </AccordionDetails>
    </Accordion>
  );
};

export default memo(DateRange);
